// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A_7e","col":"styles_col__2zPjJ","actions":"styles_actions__klKZm","conflict":"styles_conflict__KOrVw"};